/* globals getApp swan */
import md5 from './md5';
/**
 * 获取用户信息的方法
 */
import { request } from '../utils/request';
import { reqPathTo } from '../../static/utils/env';
export const getUserInfo = () => {
  return new Promise(resolve => {
    request({
      url: reqPathTo('getuserinfo', {}, '', 'falv/user')
    }).then(res => {
      let data = res && res.data && res.data.data || {};
      resolve(data);
    }).catch(() => {
      resolve({});
    });
  });
};

/**
 * 获取加密后的搜索 query
 * @return {string} searchQuery
 */

export const getSearchQuery = () => {
  return '';
};
/**
 * 获取ctk
 * @returns 经过md5加密生成的ctk
 */

export const createCtk = () => {
  let cookie;
  let msectime = new Date().getTime();
  let randNum = Math.random(9999) * 10000;
  cookie = document.cookie;
  randNum = (Array(4).join('0') + parseInt(randNum, 10)).slice(-4);
  return '48' + md5(cookie + msectime + randNum).substring(0, 14);
};

/**
 * 获取当前字体放大缩小比例，用于设置字体大小
 */
export const getFontSizeSetting = function () {
  let fontSizeSetting = 0;
  {
    const html = document.querySelector('body');
    const htmlSize = parseFloat(window.getComputedStyle(html, null).getPropertyValue('font-size')) / 14;
    if (htmlSize < 1 && htmlSize > 0.8) {
      fontSizeSetting = 1;
    } else if (htmlSize === 1) {
      // 正常比例
      fontSizeSetting = 2;
    } else if (htmlSize > 1 && htmlSize < 1.21) {
      fontSizeSetting = 3;
    } else if (htmlSize >= 1.21 && htmlSize <= 1.34) {
      fontSizeSetting = 4;
    } else if (htmlSize > 1.34) {
      fontSizeSetting = 5;
    }
  }
  return fontSizeSetting;
};

// h5判断是否为鸿蒙系统
export const isHarmonyOS = () => {
  const ua = navigator.userAgent;
  return /OpenHarmony/i.test(ua) || /harmonyos/i.test(ua) || /ohos/i.test(ua);
};